module.exports = __webpack_public_path__ + "static/ps1-d6f316e7e325104f0ac5888e48a5fd44.jpg";